<template>
  <section class="container">
    <div class="card-wrap mt-20 mb-20">
      <el-tabs>
        <el-row :gutter="24">
          <el-col :span="14">
            <div class="grid-content bg-purple">
              <span>文本信息</span>
              <el-form
                ref="qrForm"
                :rules="rules"
                :model="textInfo"
                class="add-form"
                label-width="100px"
                label-position="left"
                style="margin-top: 3%"
              >
                <div class="add-form-item">
                  <el-form-item label="标题：" prop="title">
                    <el-input
                      v-model="textInfo.title"
                      maxlength="50"
                      style="width: 129%"
                    />
                  </el-form-item>
                </div>
                <div
                  style="    margin-top: -3%;
    margin-left: 15%;"
                >
                  <span class="validate ml-20"> * 最多输入50个字符</span>
                </div>
                <div class="add-form-item">
                  <el-form-item label="备注：" prop="content">
                    <el-input
                      v-model="textInfo.content"
                      type="textarea"
                      :autosize="{
                        minRows: 6
                      }"
                      style="width: 137%"
                    />
                  </el-form-item>
                </div>
                <div class="add-form-item">
                  <el-form-item>
                    <el-button type="primary" @click="saveMarketing"
                      >生成二维码</el-button
                    >
                    <el-button type="primary" @click="downloadQrcode"
                      >下载二维码</el-button
                    >
                  </el-form-item>
                </div>
              </el-form>
            </div>
          </el-col>
          <div
            style="float:left;width: 1px;height: 500px; background: #d4d4d4;"
          ></div>
          <div>
            <QrCodeInfo
              ref="qrCodeInfo"
              @getTextInfoList="getTextInfoList"
              :dataInfo="dataInfo"
            />
          </div>
        </el-row>
      </el-tabs>
    </div>
    <br />
    <div>
      <el-table :data="list" style="width: 100%" border class="mt-40">
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{ scope.$index + (pageNum - 1) * pageSize + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column label="标题" width="250">
          <template slot-scope="scope">
            <span>{{ scope.row.title }}</span>
          </template>
        </el-table-column>
        <el-table-column label="内容" :fit="true">
          <template slot-scope="scope">
            <span>{{ scope.row.content }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleTextEdit(scope.row)"
              >查看</el-button
            >
            <el-button type="danger" size="mini" @click="deleteText(scope.row)"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        class="mt-20 pagination"
        background
        layout="total,prev, pager, next, jumper"
        :total="total"
        :page-size="10"
        :current-page="pageNum"
        @prev-click="handlePrePage"
        @next-click="handleNextPage"
        @current-change="handleCurrentChange"
      >
      </el-pagination>
    </div>
  </section>
</template>

<script>
import QrCodeInfo from "./webQrCodeInfo.vue";

export default {
  components: {
    QrCodeInfo
  },
  data() {
    return {
      list: [],
      textInfo: {
        title: "",
        content: ""
      },
      id: "",
      pageNum: 1,
      pageSize: 10,
      total: 0,
      rules: {
        title: [
          {
            required: true,
            message: "请输入标题",
            trigger: "blur"
          }
        ],
        content: [
          {
            required: true,
            message: "请输入内容",
            trigger: "blur"
          }
        ]
      },
      dataInfo: {}
    };
  },
  methods: {
    //生成二维码
    saveMarketing() {
      let _this = this;
      _this.$refs.qrForm.validate(isPass => {
        if (isPass) {
          _this.$refs.qrCodeInfo.createCode(_this.textInfo, 4);
        }
      });
    },
    //下载二维码
    downloadQrcode() {
      let _this = this;
      _this.$refs.qrCodeInfo.downloadQrcode();
    },
    handleTextEdit(info) {
      let _this = this;
      _this.textInfo.title = info.title;
      _this.textInfo.content = info.content;
      _this.dataInfo = {
        data: info.content,
        logoSrc: info.logo,
        size: info.size,
        foreColor: info.foreColor,
        backColor: info.backColor,
        formWork: info.formWork,
        faultToleRance: info.faultToleRance
      };
    },
    getTextInfoList() {
      let _this = this;
      let param = {
        url: "/api/textAndFile/getTestPage",
        params: {
          pageNum: _this.pageNum,
          pageSize: _this.pageSize
        }
      };

      _this.$store.dispatch("getTestList", param).then(() => {
        _this.list = _this.$store.state.newQrCode.testList.list;
        _this.total = _this.$store.state.newQrCode.testList.total;
      });
    },
    //当前页
    handleCurrentChange(value) {
      let _this = this;
      _this.pageNum = value;
      _this.getTextInfoList();
    },
    //上一页
    handlePrePage() {
      let _this = this;
      _this.pageNum -= 1;
      _this.getTextInfoList();
    },
    //下一页
    handleNextPage() {
      let _this = this;
      _this.pageNum += 1;
      _this.getTextInfoList();
    },
    //删除
    deleteText: function(row) {
      let _this = this;
      _this
        .$confirm("确定要删除该条文本二维码吗?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
        .then(() => {
          let param = {
            url: "/api/textAndFile/deleteTextAndFileById",
            params: { id: row.id }
          };

          _this.$Api
            .get(param.url, param.params)
            .then(response => {
              if (response.status === 200) {
                _this.getTextInfoList();
                _this.$message({
                  message: "文本二维码删除成功",
                  type: "success"
                });
              } else {
                _this.$message({
                  message: response.data.msg,
                  type: "error"
                });
              }
            })
            .catch(err => {});
        });
    }
  },
  created() {
    let _this = this;
    _this.getTextInfoList();
  }
};
</script>

<style lang="sass" scoped>
.add-form-item
  display: flex
.pagination
  text-align: center
.validate
  height: 110px
  font-size: 13px
  color: #E6A23C
</style>
